module.exports = __webpack_public_path__ + "static/media/instagram_mobile.03ef338d.svg";